import { render, staticRenderFns } from "./FormShareModal.vue?vue&type=template&id=ca35beda"
import script from "./FormShareModal.vue?vue&type=script&lang=js"
export * from "./FormShareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports